var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.hideLabel
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("w-input", {
                    attrs: {
                      value: _vm.contactAddress.Label,
                      label: _vm.$ct("labels.label"),
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        _vm.labelInput = $event
                      },
                      blur: function ($event) {
                        _vm.contactAddress.Label = _vm.labelInput
                      },
                      focus: function ($event) {
                        _vm.labelInput = _vm.contactAddress.Label
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.isParticulier || _vm.contactAddress.CompanyName !== null
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("w-input", {
                    ref: "CompanyName",
                    attrs: {
                      label: _vm.$ct("labels.CompanyName"),
                      fancy: "",
                      ucfirst: "",
                    },
                    on: { blur: _vm.companyNameBlur },
                    model: {
                      value: _vm.contactAddress.CompanyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.contactAddress, "CompanyName", $$v)
                      },
                      expression: "contactAddress.CompanyName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("w-input", {
                ref: "Firstname",
                attrs: {
                  label: _vm.$ct("labels.Firstname"),
                  fancy: "",
                  ucfirst: "",
                },
                model: {
                  value: _vm.contactAddress.FirstName,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "FirstName", $$v)
                  },
                  expression: "contactAddress.FirstName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: {
                  label: _vm.$ct("labels.LastName"),
                  fancy: "",
                  ucfirst: "",
                },
                model: {
                  value: _vm.contactAddress.LastName,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "LastName", $$v)
                  },
                  expression: "contactAddress.LastName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("w-input-autocomplete", {
                ref: "AddressLine1",
                attrs: {
                  value: _vm.contactAddress.AddressLine1,
                  label: _vm.$ct("labels.AddressLine1"),
                  fancy: "",
                  ucfirst: "",
                  items: _vm.autocompleteAddressItems,
                  open: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setContactAddressLine1($event)
                  },
                  blur: _vm.addressBlur,
                  "item-click": function ($event) {
                    return _vm.onAddressCompleteClicked($event)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (slotProps) {
                      return [_c("div", [_vm._v(_vm._s(slotProps.item.text))])]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("w-input", {
                ref: "AddressLine2",
                attrs: {
                  label: _vm.$ct("labels.AddressLine2"),
                  fancy: "",
                  ucfirst: "",
                },
                model: {
                  value: _vm.contactAddress.AddressLine2,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "AddressLine2", $$v)
                  },
                  expression: "contactAddress.AddressLine2",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "5" } },
            [
              _c("w-input", {
                attrs: { label: _vm.$ct("labels.Postal"), fancy: "" },
                on: {
                  blur: function ($event) {
                    return _vm.postalBlur()
                  },
                },
                model: {
                  value: _vm.contactAddress.Postal,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "Postal", $$v)
                  },
                  expression: "contactAddress.Postal",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "7" } },
            [
              _c("w-input", {
                attrs: {
                  label: _vm.$ct("labels.City"),
                  fancy: "",
                  ucfirst: "",
                },
                on: {
                  blur: function ($event) {
                    return _vm.cityBlur()
                  },
                },
                model: {
                  value: _vm.contactAddress.City,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "City", $$v)
                  },
                  expression: "contactAddress.City",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("app-country-code-autocomplete", {
                attrs: {
                  label: _vm.$ct("labels.Country"),
                  open: true,
                  ucfirst: "",
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.fetchZipcodes($event)
                  },
                },
                model: {
                  value: _vm.contactAddress.CountryCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "CountryCode", $$v)
                  },
                  expression: "contactAddress.CountryCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("app-contact-edit-address-emails", {
        attrs: { value: _vm.contactAddress, "group-id": _vm.groupId },
      }),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { label: _vm.$ct("labels.Phone"), fancy: "" },
                model: {
                  value: _vm.contactAddress.Phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "Phone", $$v)
                  },
                  expression: "contactAddress.Phone",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { label: _vm.$ct("labels.Mobile"), fancy: "" },
                model: {
                  value: _vm.contactAddress.Mobile,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "Mobile", $$v)
                  },
                  expression: "contactAddress.Mobile",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { label: _vm.$ct("labels.Fax"), fancy: "" },
                model: {
                  value: _vm.contactAddress.Fax,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "Fax", $$v)
                  },
                  expression: "contactAddress.Fax",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { label: _vm.$ct("labels.Reference"), fancy: "" },
                model: {
                  value: _vm.contactAddress.Reference,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "Reference", $$v)
                  },
                  expression: "contactAddress.Reference",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("w-input", {
                attrs: { label: _vm.$ct("labels.Gln"), fancy: "" },
                model: {
                  value: _vm.contactAddress.Gln,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactAddress, "Gln", $$v)
                  },
                  expression: "contactAddress.Gln",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.hasMultiLanguages
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("app-custom-language-select", {
                    attrs: { label: _vm.$ct("labels.Lng"), fancy: "" },
                    model: {
                      value: _vm.contactAddress.Lng,
                      callback: function ($$v) {
                        _vm.$set(_vm.contactAddress, "Lng", $$v)
                      },
                      expression: "contactAddress.Lng",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.multiPostalSelect,
            callback: function ($$v) {
              _vm.multiPostalSelect = $$v
            },
            expression: "multiPostalSelect",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "450" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("choose-city")))]),
              _c(
                "w-scroll-view",
                { attrs: { tag: "w-card-content" } },
                _vm._l(_vm.foundPostalCodes, function (postal, i) {
                  return _c(
                    "w-list-item",
                    {
                      key: i,
                      on: {
                        click: function ($event) {
                          return _vm.chooseCity(postal.city)
                        },
                      },
                    },
                    [
                      _c("w-list-item-text", [
                        _vm._v(" " + _vm._s(postal.city) + " "),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { icon: "ban" },
                      on: {
                        click: function ($event) {
                          _vm.multiPostalSelect = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }